import React, { useState } from "react";
import { Button, Popconfirm, Spin, Steps, Tooltip, message } from "antd";
import { ModalComponent } from "@comps/components"
import { ArrowRightOutlined, InfoCircleOutlined } from "@ant-design/icons";
import { makeRequest, makeRequestStateless } from "@utils/helpers";
import { getCompanyRelatedDataReq, deleteDataReq } from "../requests";
import StepOneDelete from "../../common/StepOneDelete";
import FilterSelectEmployees from "@mods/common/FilterSelectEmployees";
//const moment = require('moment');

const DeleteCompanyRoaster = (props) => {

  //========initial child states===============

  //============================
  const [loader, setLoader] = useState(false);
  const [companyRelatedData, setCompanyRelatedData] = useState([]);
  const [companyRelatedLoading, setCompanyRelatedLoading] = useState(false);
  const [selectedEmployments, setEmployments] = useState([]);
  //------------intitial steps state---------
  const [firstStepData, setFirstStepData] = useState(null);
  const [currentStep, setCurrent] = useState(0);

  const [preEmployeesFilter, setPreEmployeesFilter] = useState({})
  const [unSelectedEmployees, setUnSelectedEmployees] = useState([])
  const [selectedEmployees, setSelectedEmployees] = useState([])
  const [deleteAll, setDeleteAll] = useState(false);
  //=======================================
  const canOpenEmployeeStep = Boolean(firstStepData);
  const hasCompanyRelatedData = companyRelatedData && Object.keys(companyRelatedData).length > 0;
  const stepTooltip = {
    date: "Choose the roster date range that should be deleted.",
    employees: "Filter employees, then move the employees whose roster should be deleted into the selected list."
  }

  const renderStepTitle = (title, tooltip) => (
    <span className="create-roster-step-title">
      <span>{ title }</span>
      <Tooltip title={ tooltip } placement="top">
        <InfoCircleOutlined className="create-roster-step-help" />
      </Tooltip>
    </span>
  )

  const submitForm = (formId) => {
    document.getElementById(formId)?.requestSubmit();
  }

  const getCompanyRemoteData = () => {
    if (hasCompanyRelatedData || companyRelatedLoading) {
      return;
    }
    setCompanyRelatedLoading(true);
    makeRequestStateless(getCompanyRelatedDataReq, null, ongetCompanyRelatedDataReq, () => setCompanyRelatedLoading(false));
  }
  const ongetCompanyRelatedDataReq = (response) => {
    setCompanyRelatedData(response)
    setCompanyRelatedLoading(false)
  }

  const onSuccess = (data, res) => {
    if (data.errors.length > 0) {
      message.error(`${data.errors[0].reason}`);
      return;
    }
    else {
      message.success("Deleted successfully");
    }
    props.onCreated(data);
  }
  const onError = (err, res) => {
    message.error(res.response.data.message);
  }
  //=================Submit First Step 1==============================================
  const getStepOneData = (data) => {
    if (data.delete_all_employees !== undefined && data.delete_all_employees === true) {
      let emp_ids = '';
      if (props.employments) {
        props.employments.map((each) => (
          emp_ids += `${each.id},`
        ))
      }
      const payload = {
        shifts: {
          delete_all_employees: data.delete_all_employees,
          start_date: data.start_date ? data.start_date.format('YYYY-MM-DD') : '',
          end_date: data.end_date ? data.end_date.format('YYYY-MM-DD') : '',
        },
        emp_ids: emp_ids
      };
      makeRequest(setLoader, deleteDataReq, payload, onSuccess, onError);
    }
    else {
      setFirstStepData(data);
      getCompanyRemoteData();
      setCurrent(currentStep + 1);
    }

  }
  const onStepChange = (step) => {
    if (step === 1 && !canOpenEmployeeStep) {
      message.info("Select a date range before selecting employees.");
      return;
    }

    if (step === 1 && canOpenEmployeeStep) {
      getCompanyRemoteData();
    }
    setCurrent(step);
  }
  // ------------------------------------
  //=====================On Submit Second Step===========================
  const setSelectedEmploymentsIds = (employments) => {
    setEmployments(employments)
    let empIds = ''
    employments.employment_ids.map((each) => (
      empIds += `${each},`
    ))
    const payload = {
      shifts: {
        delete_all_employees: firstStepData.delete_all_employees,
        start_date: firstStepData.start_date ? firstStepData.start_date.format('YYYY-MM-DD') : '',
        end_date: firstStepData.end_date ? firstStepData.end_date.format('YYYY-MM-DD') : '',
        employment_ids: employments.employment_ids,
      },
      emp_ids: empIds
    };
    makeRequest(setLoader, deleteDataReq, payload, onSuccess, onError);
  }
  const onCancel = () => {
    props.onCreated(false);
  }
  const onBack = () => {
    setCurrent(currentStep - 1)
  }
  //================================Main Modal Component==================================
  return (
    <ModalComponent width={ 980 } top={ 20 } maskClosable={ false }
      className="create-roster-modal delete-roster-modal"
      rootClassName="create-roster-modal-root"
      bodyStyle={ { padding: 0 } }
      mainTitle={ (
        <div className="create-roster-modal-title">
          <span>Delete Roster</span>
        </div>
      ) }
      visible={ true } onCancel={ () => props.onCreated(false) } footer={ '' }>

      <div className="create-roster-shell">
        <Steps
          className="create-roster-steps steps-style"
          current={ currentStep }
          onChange={ onStepChange }
          responsive
          size="small"
        >
          <Steps.Step
            className="steps-step1"
            title={ renderStepTitle("Select Date", stepTooltip.date) }
          />
          <Steps.Step
            className="steps-step2"
            disabled={ !canOpenEmployeeStep }
            title={ renderStepTitle("Select Employees", stepTooltip.employees) }
          />
        </Steps>

        <div className="create-roster-content">
          { currentStep === 0 ?
            <StepOneDelete
              initialValues={ firstStepData }
              response={ getStepOneData }
              onCancel={ onCancel }
              isTimeslot={ false }
              hideFooter
              onDeleteAllChange={ setDeleteAll }
            />
            : currentStep === 1 && hasCompanyRelatedData ?
              <FilterSelectEmployees setSelectedEmploymentsIds={ setSelectedEmploymentsIds } companyRelatedData={ companyRelatedData } onCancel={ onCancel } onBack={ onBack }
                employment_ids={ selectedEmployments }
                moduleName='companyRoaster' is_delete={ true } hideFooter selected={ selectedEmployees } unSelected={ unSelectedEmployees } preFilters={ preEmployeesFilter } setSelected={ setSelectedEmployees } setUnselected={ setUnSelectedEmployees } setPrefilters={ setPreEmployeesFilter }
              />
              : <div className="create-roster-step-loading"><Spin spinning tip="Loading employees..." /></div> }
        </div>
      </div>

      <div className="create-roster-footer">
        { currentStep > 0 ?
          <Button className="button-back" onClick={ () => setCurrent(currentStep - 1) }>
            <span style={ { color: "#4079FC" } }>Back</span>
          </Button>
          : null }
        { currentStep === 0 ?
          deleteAll ?
            <Popconfirm
              title="Delete roster"
              description="Are you sure you want to delete roster for all employees in the selected date range?"
              okText="Yes"
              cancelText="No"
              onConfirm={ () => submitForm("deleteRosterStepOneForm") }
            >
              <Button className="button-next delete-roster-action" type="primary" danger loading={ loader }>Delete</Button>
            </Popconfirm>
            : <Button className="button-next" type="primary" htmlType="submit" form="deleteRosterStepOneForm">Next <ArrowRightOutlined /></Button>
          : <Popconfirm
            title="Delete"
            description="Are you sure to delete?"
            okText="Yes"
            cancelText="No"
            onConfirm={ () => submitForm("filterEmployeeForm") }
          >
            <Button className="button-next delete-roster-action" type="primary" danger loading={ loader } disabled={ !hasCompanyRelatedData }>
              Delete
            </Button>
          </Popconfirm> }
      </div>
    </ModalComponent>
  )
}
export default DeleteCompanyRoaster
